// src/components/BearthStory.jsx
import React from "react";
import { Parallax } from "react-parallax";
import NftScarcityImage from "../../../assets/images/nft-3.webp";
import { FaArrowRightLong } from "react-icons/fa6";

const BearthStory = () => {
  return (
    <Parallax
      bgImage={NftScarcityImage}
      strength={300}
      bgImageStyle={{
        objectFit: "cover",
        width: "100%",
        height: "100%",
      }}
    >  
      <section
        className="bearth-story nftscarcity"
        id="bearthstorysec"
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "flex-end",
          color: "#fff",
        }}
      >
        <img className="astronauts-bear" alt="" src={require('../../../assets/images/index-logo-7.png')} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-11">
              <div className="text-wrapper">
                <h2 className="mbr-section-title mbr-fonts-style display-2">NFT Rarity</h2>
                <p>The little bear sets out on a journey across distant planets, seeking solutions to save its fragmented homeland. On each planet it lands, it gains precious gems through learning and exploration. Each gem holds a unique power—together, they are the keys to rebuilding the shattered Bearth.</p>

              </div>
            </div>
          </div>
        </div>
      </section>
    </Parallax>
  );
};

export default BearthStory;
